import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var OV = function OV(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Outdoor Voices \"OV\" Logo"
    }), /*#__PURE__*/_jsx("path", {
      "aria-hidden": "true",
      d: "m16.3 14-2.2-6h-2l3.3 8.3h1.8l3.2-8.3h-1.9z"
    }), /*#__PURE__*/_jsx("path", {
      "aria-hidden": "true",
      d: "m7.7 7.9c-2.4 0-4.3 1.9-4.3 4.3 0 2.4 1.9 4.3 4.3 4.3s4.3-1.9 4.3-4.3c0-2.4-2-4.3-4.3-4.3zm2.4 4.3c0 1.3-1.1 2.4-2.4 2.4s-2.4-1.1-2.4-2.4c0-1.3 1.1-2.4 2.4-2.4s2.4 1.1 2.4 2.4z"
    })]
  });
};

export default OV;